<template>
  <div>
    <Navigation />
    <div class="grid__section">
    <section class="section__container top__container blog__details">
            

      <h1 class="title center__text">
        ENVOI SMS POUR LES PROFESSIONNELS DE SANTÉ, PHARMACIE, AMBULANCES, VÉTÉRINAIRES
      </h1>
          <img class="card__image" src="/../images/sante.png" alt="" />
      <p>
        Si vous êtes secrétaire médicale, notre plateforme vous offre la solution idéale pour gagner du temps en 
        envoyant des SMS en masse à vos contacts pour rappeler les rendez-vous. L'organisation de votre accueil
        public sera améliorée et simplifiée grâce à cette plateforme SMS. Vous pourrez optimiser la gestion de
        votre agenda et réduire jusqu'à 75% le taux de rendez-vous manqués en raison de l'absentéisme. Avec Servicesms.sn,
        vous pouvez envoyer directement des SMS en masse aux contacts de vos clients en un simple clic.
      </p>
      <p>
        Votre patient recevra une alerte SMS lui rappelant de ne pas oublier son rendez-vous à votre cabinet à la date prévue.
      </p>
      <h2>Voici les avantages offerts par le rappel de rendez-vous avec Servicesms.sn :</h2>

      <p>
        Le SMS est le moyen de rappel le plus efficace, avec un taux d'ouverture et de mémorisation de 95%, surtout lorsque 
        vous le planifiez la veille à une heure précise, comme en début de soirée. Il sera lu dans les cinq minutes suivant 
        son envoi grâce à notre solution SMS PRO.
      </p>
      <h2>
        Médecins, laboratoires, infirmières et professionnels de l'Hospitalisation à Domicile (HAD)
      </h2>
      <p>
        Les professionnels de santé sont tous confrontés à la gestion de leur agenda au sein de leur secrétariat médical. 
        Utilisez servicesms.sn pour améliorer la proximité avec vos patients.
      </p>
      <h2>
        Il existe différentes situations pour lesquelles l’envoi de SMS serait
        utile dans le domain médical.
      </h2>
        <li>Rappels de rendez-vous<br /></li>
        <li>Avis de passages pour des soins<br /></li>
        <li>Réponses aux demandes d'interventions<br /></li>
        <li>Avis de livraison de dispositifs médicaux<br /></li>
        <li>Envoi de résultats et diagnostics par SMS<br /></li>
        <li>SMS contenant un mot de passe unique pour accéder à un extranet sécurisé (résultats d'analyses)<br /></li>
        <li>SMS prévenant d'un retard<br /></li>
        <li>Communication avec tous vos partenaires</li>
      
      <p>
        Grâce à notre solution d'envoi en masse de SMS professionnels, vous pourrez gérer toutes ces circonstances 
        et permettre à vos partenaires de santé de réduire la distance et le temps d'attente des patients à domicile
        ou au cabinet.
      </p>
    
      <h2>Quelques exemples de SMS :</h2>
      <div class="cards">
        <div class="card">
          <img class="card__image" src="/../images/sante-pharma-1.png" />
        </div>
        <div class="card">
          <img class="card__image" src="/../images/sante-pharma-2.png" />
        </div>
        <div class="card">
          <img class="card__image" src="/../images/sante-pharma-3.png" />
        </div>
      </div>
     
    
    </section>
    <SideNav/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Navigation from "./Navigation";
import Footer from "./Footer";
import SideNav from "./SideNav";
export default {
  components: {
    Navigation,
    Footer,
    SideNav
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";
</style>
